import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppConfig} from "../../app.config";
import {HttpService} from "../../services/http.service";
import {RightPanelComponent} from "../right-panel/right-panel.component";


@Component({
    selector: 'app-blog-comment',
    templateUrl: './blog-comment.component.html'
})
export class BlogCommentComponent implements OnInit {
    @Input() public blog: any;
    @Output() public getLastComments: EventEmitter<any> = new EventEmitter<any>();

    public comments: any;
    public model = {};
    public limit = 2;
    public wasSent = false;

    constructor(public http: HttpService) {
    }

    ngOnInit() {
        this.getComments(this.limit);
    }

    loadMore() {
        this.limit += 2;
        this.getComments(this.limit);
    }

    getComments(limit) {
        this.http.get(AppConfig.baseUrlApi + 'comments/api_comments?article_id=' + this.blog.id_article + '&limit=' + limit)
            .subscribe(response => {
                this.comments = response.content;
            }, error => {
                console.log(error);
            });
        console.log('tyt');
    }

    sendComment(event) {
        event.preventDefault();

        const formData = new FormData();
        const url = AppConfig.baseUrlApi + 'comments/api_insert_comment';

        for (let name in this.model) {
            if (!this.model.hasOwnProperty(name)) {
                continue;
            }
            formData.append(name, this.model[name]);
        }
        formData.append('id_article', this.blog.id_article);
        this.http.post(url, formData).subscribe(response => {
            if (response.message === 'ok') {
                alert('Message was sent');
                this.model = {};
                this.getComments(this.limit);
                this.wasSent = true;
                this.getLastComments.emit();
            } else {
                alert(response.content);
            }
        }, error => {
            console.log(error);
        });
    }

}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/blog/blog-comment/blog-comment.component.ts